import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCarOutlined';
import type { RentCarSearchResponse, RentCarVehicle } from '../../../api/types/rentCar';
import { extractVehicles, formatCurrency, vehicleDisplayName } from '../utils';

interface VehicleResultsStepProps {
  searchResult: RentCarSearchResponse;
  loading?: boolean;
  onSelect: (vehicle: RentCarVehicle) => void;
  onBackToSearch: () => void;
}

export function VehicleResultsStep({ searchResult, loading, onSelect, onBackToSearch }: VehicleResultsStepProps) {
  const vehicles = extractVehicles(searchResult.carListingSearchResponse);

  return (
    <Box>
      <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Arama Sonuçları</Typography>
        <Button onClick={onBackToSearch}>Aramaya Dön</Button>
      </Stack>

      {vehicles.length === 0 && (
        <Alert severity="warning">
          Bu arama için sonuç bulunamadı. (Bu test hesabında RentCar için tanımlı lokasyon/sağlayıcı verisi
          olmayabilir — bkz. GetLocations boş liste dönüyor.)
        </Alert>
      )}

      <Grid container spacing={2}>
        {vehicles.map((vehicle, idx) => (
          <Grid key={vehicle.id ?? vehicle.code ?? idx} size={{ xs: 12, md: 6, lg: 4 }}>
            <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1 }}>
                  <DirectionsCarIcon color="action" />
                  <Typography variant="subtitle1">{vehicleDisplayName(vehicle)}</Typography>
                </Stack>
                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', mb: 1 }}>
                  {vehicle.category && <Chip size="small" label={vehicle.category} />}
                  {vehicle.transmission && <Chip size="small" label={vehicle.transmission} />}
                  {vehicle.fuelType && <Chip size="small" label={vehicle.fuelType} />}
                  {vehicle.seatCount && <Chip size="small" label={`${vehicle.seatCount} koltuk`} />}
                </Stack>
                {vehicle.supplier && (
                  <Typography variant="body2" color="text.secondary">
                    Tedarikçi: {vehicle.supplier}
                  </Typography>
                )}
                <Typography variant="h6" sx={{ mt: 1 }}>
                  {formatCurrency(vehicle.totalFare ?? vehicle.baseFare, vehicle.currency)}
                </Typography>
              </CardContent>
              <CardActions>
                <Button fullWidth variant="contained" disabled={loading} onClick={() => onSelect(vehicle)}>
                  Seç
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
